import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { LandingPage as LandingPageForm } from '@bgea-js/form-templates';
import decisionMagazineHardCopy from "./customConfirmationHardcopy";
import './pray-president.scss';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

<p className="supply"><strong>While supplies last; one per household; please allow 2–4 weeks for delivery; U.S. residents only.</strong></p>
<div className="form-container-hc">
<LandingPageForm SESourceCode="BD251LPFP" addressVisible={['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode']} buttonText="SEND MY FREE ISSUE" checkBox18Text="I am 18 or older*" collectionType={489} country={['US']} customConfirmation={decisionMagazineHardCopy} destination={2} emailId="NewNames" emailTemplateCampaign="NN Decision Magazine Hard Copy" esubCodes={['BGEA', 'DMAGNL']} isChecked lng="en" maxPostalCodeLength={5} minPostalCodeLength={5} priceCode={[{
        amount: 0,
        productId: 'DMJAN25KIT',
        quantity: 1,
        warehouse: 'DECISION'
      }]} privacyPolicyCopy="By providing your personal details, you accept that we will use your personal details to communicate with you about ministry updates and opportunities from Billy Graham Evangelistic Association.  <a href='https://billygraham.org/privacy-policy/' target='_blank'>  View our full Privacy Policy. </a>" show18Checkbox specialCode={[]} mdxType="LandingPageForm" />
 </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      